// extracted by mini-css-extract-plugin
export var section = "graphic-header-module--section--CgDAo";
export var arrowColumn = "graphic-header-module--arrowColumn--NDsAe";
export var textColumn = "graphic-header-module--textColumn--YYSd3";
export var arrow = "graphic-header-module--arrow--5ZeLL";